(function () {
  'use strict';

  angular
      .module('tfc.Files')
      .controller('FilesCtrl', FilesCtrl);

  // @ngInject
  function FilesCtrl($filter,
                     reports,
                     reportsCount,
                     retailers,
                     ReportUtil,
                     $uibModal,
                     Reports,
                     Toast,
                     Auth,
                     PageSize,
                     $interpolate,
                     $stateParams,
                     $translate) {
    var vm = this;
    var editingReport = null;
    var reportTitleFilter = $filter('reportTitle'),
        translateFilter = $filter('translate');
    retailers = _.keyBy(retailers, 'tla');
    vm.fileType = ReportUtil.fileType;
    vm.openReport = ReportUtil.openReport;
    vm.reports = getSortedReports(reports);
    vm.params = _.cloneDeep($stateParams);
    vm.reportCount = reportsCount.count;
    vm.currentPage = 1;
    vm.pageSize = PageSize;
    vm.maxSize = 7;

    vm.treeStructure = getTreeStructure();

    if (vm.params.tla) {
      vm.retailerFilter = (retailers[vm.params.tla] && retailers[vm.params.tla].name) || '';
      vm.reports = vm.treeStructure[vm.params.tla] || [];
      if (vm.params.year) {
        vm.yearFilter = vm.params.year;
        vm.reports = vm.reports[vm.params.year];
        if (vm.params.category) {
          vm.categoryFilter = $translate.instant('report.category.' + vm.params.category);
          vm.reports = vm.reports[vm.params.category]
        } else { // there's no category, stopping and flattening
          vm.reports = _.flatten(_.values(vm.reports));
        }
      } else { // there's no year, stopping and flattening
        vm.reports = _.mapValues(vm.reports, function (yearGroup) {
          var yearGroupArrays = _.values(yearGroup);
          return _.flatten(yearGroupArrays);
        });
        vm.reports = _.flatten(_.values(vm.reports));
      }
    }

    vm.canAudit = function () {
      return Auth.can('retailerAuditor');
    };

    vm.editReport = function (report) {
      if (vm.isEditing(report)) {
        editingReport = null;
      } else {
        editingReport = report;
      }
      if (vm.canAudit() && !report.audit) {
        Reports.audit(report.fileKey).then(function (audit) {
          report.audit = audit;
        });
      }
    };

    vm.isEditing = function (report) {
      return report === editingReport;
    };

    vm.toggleActive = function (report) {
      Reports.update({ fileKey : report.fileKey, isActive : !report.isActive, sendEmail: report.sendEmail }).then(function (updated) {
        report.sendEmail = false;
        _.extend(report, updated);
        Toast.success(
            report.isActive ? 'files.mgmt.activated' : 'files.mgmt.deactivated',
            { data : { report : report } }
        );
      });
    };

    vm.deleteReport = function (report) {
      var modal = $uibModal.open({
        templateUrl : 'Files/ConfirmDelete.tmpl.html',
        controller : function ($scope) {
          $scope.report = report;
        }
      });

      modal.result.then(function () {
        Reports.delete(report.fileKey).then(function () {
          var index = vm.reports.indexOf(report);
          if (~index) {
            vm.reports.splice(index, 1);
          }
          Toast.success('files.mgmt.deleted', { data : { report : report }});
        });
      });
    };

    vm.pageChange = function(currentPage){
      vm.currentPage = currentPage;
      Reports.find($stateParams.tla, $stateParams.category, $stateParams.year, vm.pageSize, vm.currentPage, vm.search).then(function (response) {
        vm.reports = [];
        vm.reports = getSortedReports(response);
        callUploadFiles(response);
      });
    };

    function callUploadFiles(reports){
      _.each(reports, function (report) {
        // attach other fields so they can be searched
        report.retailerName = retailers[report.tla] && retailers[report.tla].name;  // condition for in case retailer doesn't exist for tla
        report.title = reportTitleFilter(report);
        report.fileType = translateFilter('report.fileType.' + ReportUtil.fileType(report));
      });
    }

    function getTreeStructure() {
      // retailer->reports Map
      var retailerGroups = _.groupBy(vm.reports, 'tla');
      // return retailer->years, year->categories, category->reports map
      return _.mapValues(retailerGroups, function (retailerGroup) {
        //take each retailer->reports Map and make it into a retailer->years, year->reports Map
        var retailerYearGroups =  _.groupBy(retailerGroup, function (report) {
          var getYear = $interpolate("{{ created | date: 'yyyy' }}");
          return getYear(report);
        });
        //take each year->reports Map and make it into a year->categories, category->reports Map
        return _.mapValues(retailerYearGroups, function (yearGroup) {
          return _.groupBy(yearGroup, 'key.category');
        });
      });
    }

    function getSortedReports(reports) {
      return ReportUtil.sort(reports,'lastUpdated', 'desc');
    }

    vm.searchTextChange = function () {
      Reports.reportCount($stateParams.tla, $stateParams.category, $stateParams.year, vm.pageSize, vm.currentPage,vm.search).then(function (response) {
        if (response.count> 0) {
          vm.pageChange(1);
        } else {
          vm.reports = [];
        }
        vm.reportCount = response.count;
      });
    };

    callUploadFiles(reports);
  }

})();
